import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tgadvisory-community',
  templateUrl: './tgadvisory-community.component.html',
  styleUrls: ['./tgadvisory-community.component.scss']
})
export class TgadvisoryCommunityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
